import React from 'react';

const BrandLabel = () => (
  <div className="absolute top-4 left-4 z-30 select-none pointer-events-none">
    <span className="text-2xl sm:text-3xl font-extrabold tracking-wide text-gray-800/80">
      VERVESTACKS
    </span>
  </div>
);

export default React.memo(BrandLabel);
